module.exports = __webpack_public_path__ + "img/laptop_roturas.3dafd61e.svg";